const countries = [
  {
    language: "af",
    flag: "ZA",
  },
  {
    language: "ak",
    flag: "GH",
  },
  {
    language: "sq",
    flag: "AL",
  },
  {
    language: "am",
    flag: "ET",
  },
  {
    language: "ar",
    flag: "SA",
  },
  {
    language: "hy",
    flag: "AM",
  },
  {
    language: "as",
    flag: "IN",
  },
  {
    language: "ay",
    flag: "BO",
  },
  {
    language: "az",
    flag: "AZ",
  },
  {
    language: "bm",
    flag: "ML",
  },
  {
    language: "eu",
    flag: "ES",
  },

  {
    language: "be",
    flag: "BY",
  },
  {
    language: "bn",
    flag: "BD",
  },
  {
    language: "bho",
    flag: "IN",
  },
  {
    language: "bs",
    flag: "BA",
  },
  {
    language: "bg",
    flag: "BG",
  },
  {
    language: "ca",
    flag: "ES",
  },
  {
    language: "ceb",
    flag: "PH",
  },
  {
    language: "ny",
    flag: "MW",
  },

  {
    language: "zh",
    flag: "cn",
  },
  {
    language: "zh-TW",
    flag: "tw",
  },
  {
    language: "co",
    flag: "fr",
  },
  {
    language: "hr",
    flag: "hr",
  },
  {
    language: "cs",
    flag: "cz",
  },
  {
    language: "da",
    flag: "dk",
  },
  {
    language: "dv",
    flag: "mv",
  },
  {
    language: "doi",
    flag: "in",
  },
  {
    language: "nl",
    flag: "nl",
  },
  {
    language: "en",
    flag: "gb",
  },
  {
    language: "eo",
    flag: "un",
  },
  {
    language: "et",
    flag: "ee",
  },
  {
    language: "ee",
    flag: "tg",
  },

  {
    language: "tl",
    flag: "ph",
  },
  {
    language: "fi",
    flag: "fi",
  },
  {
    language: "fr",
    flag: "fr",
  },
  {
    language: "fy",
    flag: "nl",
  },
  {
    language: "gl",
    flag: "es",
  },
  {
    language: "lg",
    flag: "ug",
  },
  {
    language: "ka",
    flag: "ge",
  },
  {
    language: "de",
    flag: "de",
  },
  {
    language: "gom",
    flag: "in",
  },
  {
    language: "el",
    flag: "gr",
  },
  {
    language: "gn",
    flag: "py",
  },

  {
    language: "gu",
    flag: "in",
  },
  {
    language: "ht",
    flag: "ht",
  },
  {
    language: "ha",
    flag: "ng",
  },
  {
    language: "haw",
    flag: "us",
  },
  {
    language: "iw",
    flag: "il",
  },
  {
    language: "hi",
    flag: "in",
  },
  {
    language: "hmn",
    flag: "cn",
  },
  {
    language: "hu",
    flag: "hu",
  },
  {
    language: "is",
    flag: "is",
  },
  {
    language: "ig",
    flag: "ng",
  },
  {
    language: "ilo",
    flag: "ph",
  },
  {
    language: "id",
    flag: "id",
  },

  {
    language: "ga",
    flag: "IE",
  },
  {
    language: "it",
    flag: "IT",
  },
  {
    language: "ja",
    flag: "JP",
  },
  {
    language: "jw",
    flag: "ID",
  },
  {
    language: "kn",
    flag: "IN",
  },
  {
    language: "kk",
    flag: "KZ",
  },
  {
    language: "km",
    flag: "KH",
  },
  {
    language: "rw",
    flag: "RW",
  },
  {
    language: "ko",
    flag: "KR",
  },
  {
    language: "kri",
    flag: "SL",
  },

  {
    language: "ku",
    flag: "kw",
  },
  {
    language: "ckb",
    flag: "iq",
  },
  {
    language: "ky",
    flag: "kg",
  },
  {
    language: "lo",
    flag: "la",
  },
  {
    language: "la",
    flag: "vatican-city-state-holy-see",
  },
  {
    language: "lv",
    flag: "lv",
  },
  {
    language: "ln",
    flag: "cd",
  },
  {
    language: "lt",
    flag: "lt",
  },
  {
    language: "lb",
    flag: "lu",
  },
  {
    language: "mk",
    flag: "mk",
  },
  {
    language: "mai",
    flag: "in",
  },
  {
    language: "mg",
    flag: "mg",
  },

  {
    language: "ms",
    flag: "my",
  },
  {
    language: "ml",
    flag: "in",
  },
  {
    language: "mt",
    flag: "mt",
  },
  {
    language: "mni-Mtei",
    flag: "in",
  },
  {
    language: "mi",
    flag: "nz",
  },
  {
    language: "mr",
    flag: "in",
  },
  {
    language: "lus",
    flag: "in",
  },
  {
    language: "mn",
    flag: "mn",
  },
  {
    language: "my",
    flag: "mm",
  },

  {
    language: "ne",
    flag: "np",
  },
  {
    language: "nso",
    flag: "za",
  },
  {
    language: "no",
    flag: "no",
  },
  {
    language: "or",
    flag: "in",
  },
  {
    language: "om",
    flag: "et",
  },
  {
    language: "ps",
    flag: "af",
  },
  {
    language: "fa",
    flag: "ir",
  },
  {
    language: "pl",
    flag: "pl",
  },
  {
    language: "pt",
    flag: "pt",
  },
  {
    language: "pa",
    flag: "in",
  },
  {
    language: "qu",
    flag: "pe",
  },
  {
    language: "ro",
    flag: "ro",
  },
  {
    language: "ru",
    flag: "ru",
  },
  {
    language: "sm",
    flag: "ws",
  },

  {
    language: "sa",
    flag: "in",
  },
  {
    language: "gd",
    flag: "scotland",
  },
  {
    language: "sr",
    flag: "rs",
  },
  {
    language: "st",
    flag: "ls",
  },
  {
    language: "sn",
    flag: "zw",
  },
  {
    language: "sd",
    flag: "pk",
  },
  {
    language: "si",
    flag: "lk",
  },
  {
    language: "sk",
    flag: "sk",
  },
  {
    language: "sl",
    flag: "si",
  },

  {
    language: "so",
    flag: "SO",
  },
  {
    language: "es",
    flag: "ES",
  },
  {
    language: "su",
    flag: "ID",
  },
  {
    language: "sw",
    flag: "TZ",
  },
  {
    language: "sv",
    flag: "SE",
  },
  {
    language: "tg",
    flag: "TJ",
  },
  {
    language: "ta",
    flag: "IN",
  },

  {
    language: "tt",
    flag: "TM",
  },
  {
    language: "te",
    flag: "IN",
  },
  {
    language: "th",
    flag: "TH",
  },
  {
    language: "ti",
    flag: "ER",
  },
  {
    language: "ts",
    flag: "ZA",
  },
  {
    language: "tr",
    flag: "TR",
  },
  {
    language: "tk",
    flag: "TM",
  },
  {
    language: "uk",
    flag: "UA",
  },
  {
    language: "ur",
    flag: "PK",
  },
  {
    language: "ug",
    flag: "CN",
  },
  {
    language: "uz",
    flag: "UZ",
  },
  {
    language: "vi",
    flag: "VN",
  },
  {
    language: "cy",
    flag: "WLS",
  },

  {
    language: "xh",
    flag: "za",
  },
  {
    language: "yi",
    flag: "il",
  },
  {
    language: "yo",
    flag: "ng",
  },
  {
    language: "zu",
    flag: "za",
  },
  {
    language: "he",
    flag: "il",
  },
  {
    language: "jv",
    flag: "id",
  },
  {
    language: "zh-CN",
    flag: "cn",
  },
];

export default countries;
